import { Component, OnInit } from '@angular/core';
import { DevicePictureScanSettings, HttpService } from '@sdbn/appclient';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DeviceProperty } from '../../register-entrance-leave.model';
import { SelectFieldOption } from '@sdbn/common';

@Component({
  selector: 'app-picture-series-task-dialog',
  templateUrl: './picture-series-task-dialog.component.html',
  styleUrls: ['./picture-series-task-dialog.component.scss']
})
export class PictureSeriesTaskDialogComponent implements OnInit {


  currentSelection: string[];

  deviceSettings = new DevicePictureScanSettings({
    deviceId: '32a4c66a92959e5d8967085d3e3718611a917427b034f4761728a621a6c17588',
    rotation: 0,
    topLeftX: 1350,
    topLeftY: 40,
    height: 450,
    width: 300
  });

  selectedConfiguration: DevicePictureScanSettings;

  selectConfigurationForm = new FormGroup({
    model: new FormControl(null, [])
  });

  options = new Array<SelectFieldOption>();

  constructor(
    public dialogRef: MatDialogRef<PictureSeriesTaskDialogComponent>,
    private http: HttpService
  ) { }

  ngOnInit(): void {

    this.selectConfigurationForm.valueChanges.subscribe(value => {
      this.selectedConfiguration = value.model;
    });

    this.http.postWithContext<DeviceProperty[]>(environment.tmcBaseUrl + '/client/deviceproperty/byDeviceType', "PICTURE_SCANNER").subscribe(response => {
      let options = new Array<SelectFieldOption>();
      for (let entry of response) {
        if (entry.key === 'camera-config') {
          let option = new SelectFieldOption();
          option.label = entry.deviceId;
          option.value = new DevicePictureScanSettings(JSON.parse(entry.value));
          options.push(option);
        }
      }
      this.options = options;
      if (this.options.length > 0) {
        this.selectConfigurationForm.patchValue({ model: this.options[0].value });
      }
    });

  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close(this.currentSelection);
  }

  handleSelection(selection: string[]) {
    this.currentSelection = selection;
  }

}
